import { render, staticRenderFns } from "./IssueMap.vue?vue&type=template&id=1ddb2fe2&scoped=true&"
import script from "./IssueMap.vue?vue&type=script&lang=js&"
export * from "./IssueMap.vue?vue&type=script&lang=js&"
import style0 from "./IssueMap.vue?vue&type=style&index=0&id=1ddb2fe2&scoped=true&lang=css&"
import style1 from "./IssueMap.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb2fe2",
  null
  
)

export default component.exports